export default "__VITE_ASSET__a3a18595__"